import { useContext } from 'react';
import { FinancingChartsDataContext } from '../contexts/FinancingChartsDataContext';

export const useFinancingChartsDataContext = () => {
    return useContext(FinancingChartsDataContext);
};
